function isDate(obj) {
	var fields = [
		"getFullYear",
		"getMonth",
		"getDate"
	];
	
	if (obj && typeof obj == "object") {
		for (var i=0; i<fields.length; i++) {
			if (!obj[fields[i]])
				return false;
		}
	} else {
		return false;
	}

	return true;
}

module.exports = {
	isDate: isDate
};


//////////////////
// WEBPACK FOOTER
// ./sources/utils/date_helpers.js
// module id = 3
// module chunks = 0